import { gql } from "@apollo/client";

const HideUserByTokenMutation = gql`
  mutation HideUserByTokenMutation($token: ID!, $language: String) {
    hideUserByToken(token: $token, language: $language)
  }
`;

export default HideUserByTokenMutation;
